import { Box, Button, Link, Paper, Typography } from "@mui/material"
import { usePreferences } from "./PreferencesProvider"

const BRAND_GREEN = '#042930'

const Strings = {
  Title: 'Nuestras cookies',
  Message:
    'Usamos cookies para mejorar la experiencia, analizar el tráfico y ofrecer funcionalidades que hace el uso del sitio más cómodo y seguro. Puedes aceptar todas, rechazarlas o configurar tus preferencias. Si quieres saber más, echa un vistazo a nuestra',
  CookiePolicy: 'Política de Cookies',
  AcceptAll: 'Aceptar todas',
  AcceptNecessary: 'Solo necesarias',
  Configure: 'Configurar',
  Save: 'Guardar',
  Necessary: 'Cookies Necesarias',
  Analytics: 'Cookies Analíticas',
}

export function PreferencesBanner() {
  const ctx = usePreferences()
  if (ctx.isBannerHidden) return null

  const buttonSx = {
    minWidth: 160,
    borderRadius: 2,
    bgcolor: '#C9C9CF',
    color: BRAND_GREEN,
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      bgcolor: '#afafb6',
    },
  };

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        left: 20,
        right: 20,
        bottom: 20,
        maxWidth: 800,
        mx: 'auto',
        p: { xs: 3, md: 4 },
        borderRadius: 5,
        zIndex: (theme) => theme.zIndex.snackbar,
      }}
    >
      <Typography variant="h5" fontWeight={600} sx={{ mb: 1.5 }}>
        {Strings.Title}
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, mt: 1, lineHeight: 1.4 }}>
        {Strings.Message}{' '}
        <Link
          href="https://zyrapp.com/cookies"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: BRAND_GREEN, fontWeight: 600, underline: 'none', textDecoration: 'underline' }}
        >
          {Strings.CookiePolicy}
        </Link>
        .
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          gap: 1.5,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 1.5 }}>
          <Button variant="contained" onClick={ctx.acceptAll} sx={buttonSx}>
            {Strings.AcceptAll}
          </Button>
          <Button variant="contained" onClick={ctx.acceptNecessary} sx={buttonSx}>
            {Strings.AcceptNecessary}
          </Button>
        </Box>
        <Button variant="contained" onClick={() => ctx.setDialogOpen(true)} sx={buttonSx}>
          {Strings.Configure}
        </Button>
      </Box>
    </Paper>
  )
}
